
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useHistory } from 'react-router-dom';

const Container = styled.div`
cursor: pointer;
    .anticon{
        color: ${THEME.colors.primary};
        margin-right: 5px;
    }
    label{
        font-weight: bold;
    }
    
`;

const ModalContainer = styled.div`
    .thead, .tbody{
        width: 100%;
        padding: 5px;
        span{
            display: inline-block;
            width: 33.33%;
            text-align: left;
        }
    }

    .thead{
        span{
            font-weight: bold;
            color: #555;
        }
    }
    .tbody{
        cursor: pointer;
        &.selected{
            background-color: ${THEME.colors.primary};
            span{
                color: #fff;
                &:first-child{
                    color: #fff;
                }
            }
        }
        &:hover{
            background-color: ${THEME.colors.primary};
            span{
                color: #fff;
                &:first-child{
                    color: #fff;
                }
            }
        }
        span {
            &:first-child{
                color: ${THEME.colors.primary};
            }
            
        }
    }
`

function NewVendor(props) {
    const history = useHistory()
    const [visible, setVisible] = useState(false)
    const [selected, setSelected] = useState('company')

    const okHandler = () => {
        setVisible(false);
        history.push(`/crm/vendors/new/${selected}`, { prevPath: '/crm/vendors'} )
    }

    return (
        <Container>
            <PlusOutlined onClick={() => setVisible(true)} />
            <label>New</label>
            <Modal
                visible={visible}
                centered
                title="Select a template for a new vendor"
                okButtonProps={{ style: { backgroundColor: THEME.colors.primary } }}
                width={600}
                closable={false}
                bodyStyle={{ background: '#F2F2F2' }}
                footer={[
                    <Button key="ok" type="primary" onClick={okHandler} style={{ backgroundColor: THEME.colors.primary, borderColor: THEME.colors.primary}}>OK</Button>,
                    <Button key="cancel" onClick={() => setVisible(false)}>Cancel</Button>
                ]}
            >
                <ModalContainer>

                    <div className='thead' >
                        <span> Code </span>
                        <span> Description </span>
                        <span> Contact Type </span>
                    </div>

                    <div onClick={() => setSelected('company')} className={`tbody ${selected === 'company' ? 'selected' : ''}`} >
                        <span> Vendor Company </span>
                        <span> Business to Business </span>
                        <span> Company </span>
                    </div>

                    <div onClick={() => setSelected('person')} className={`tbody ${selected === 'person' ? 'selected' : ''}`} >
                        <span> Vendor Person </span>
                        <span> Individual </span>
                        <span> Person </span>
                    </div>

                </ModalContainer>
            </Modal>
        </Container>
    )
}

NewVendor.propTypes = {}

export default NewVendor